import { render, staticRenderFns } from "./shopb.vue?vue&type=template&id=8a9454d8&"
import script from "./shopb.vue?vue&type=script&lang=js&"
export * from "./shopb.vue?vue&type=script&lang=js&"
import style0 from "./shopb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports